import {msgVar} from '@betrue/store';
import PropTypes from 'prop-types';
import React, {useEffect} from "react";
import {useReactiveVar} from "@apollo/client";


/**
 * Component that expose the title
 */

export  function ElementorWidgetsTitle({label, lastValue}) {
  return (
    <h1>
      {' '}
      {label ? `${label}: ` : 'Title: '} {lastValue}{' '}
    </h1>
  );
}

export function ElementorWidgetsTitleGqlStore({label}: { label: string }) {
  const v = useReactiveVar(msgVar)

  return <ElementorWidgetsTitle lastValue={v} label={label}/>;

}

/**
 * Exposing props to elementor through the web component
 * /!\ o not use this for state management
 */
ElementorWidgetsTitleGqlStore.propTypes = {
  label: PropTypes.string,
};
